import Game from "./Game";
import SoundManager from "./SoundManager";
import User from "./User";
import System from "./System";
import Match from "./Match";
import {StrokeTracker} from "./stroke";
import {PlayerSettings} from "./settings";

let Cue:any = {
    Distance: 1.5,
    LastUpdate: Date.now(),
    Size: 6.3,
    horizontalAngle: 0,
    verticalAngle: 0.1,
    RenderedBody: {},
    Enabled: true,
    HasShot: false,
    // Stroke speed tracking (see stroke.ts): power = hand speed over the last ~80 ms.
    Tracker: new StrokeTracker(),
    StrokeActive: false,
    LastShot: {speed: 0, t: -Infinity},
    // notified synchronously on every stroke change (the power meter uses it so it never lags a frame)
    StrokeListeners: new Set<() => void>(),
    NotifyStroke: function(){ Cue.StrokeListeners.forEach((l: () => void) => l()); },
    Init: function(){
        let loader = new THREE.OBJMTLLoader();
        loader.addEventListener( 'load', function (event:any) {

            let object = event.content;
            Cue.RenderedBody = object;

            let copyBallPosition = function(rendered:any, physical:any){
                rendered.position.x = physical.GetPosition().x;
                rendered.position.z = physical.GetPosition().y;
                rendered.position.y = 7.926842;
            };

            copyBallPosition(Cue.RenderedBody, Game.Scenario.WhiteBall.PhysicalBody)

            Game.Scenario.scene.add( object );

            if (!Game.State.MyTurn()){
                Cue.Distance = 1.3;

                Cue.RenderedBody.position.y = 2000;
                Cue.Enabled = false;
            }
        });
        loader.load( '../Models/Snooker/Centralizados/Taco/taco.obj', '../Models/Snooker/Centralizados/Taco/taco.mtl' );
    },
    /**
     * Space pressed: lock the aim and enable stroking. The cue does not move: it stays where it was when
     * Space was released (or at rest if no stroke started), as in the original game. The tracker is
     * reset to rest after every shot and at the start of each turn, never here.
     */
    StartStroke: function(t:number){
        Cue.Tracker.resume(t);
        Cue.StrokeActive = true;
        Cue.NotifyStroke();
    },
    EndStroke: function(){
        Cue.StrokeActive = false;
        Cue.NotifyStroke();
    },
    /** Mouse moved with Space held: dy > 0 draws the cue back, dy < 0 pushes it through the ball. */
    Stroke: function(dy:number, t:number){
        if (!Cue.Enabled) return;
        if (!Cue.StrokeActive) Cue.StartStroke(t);
        const r = Cue.Tracker.move(dy, t);
        Cue.Distance = r.fire ? 1.11 : Cue.Tracker.distance;
        Cue.NotifyStroke();
        if (Cue.RenderedBody && Cue.RenderedBody.position) Cue.RenderedBody.position.copy(Game.Scenario.WhiteBall.Rendered.position);
        if (!r.fire) return;

        SoundManager.mute = false;

        Cue.HasShot = true;
        if(!User.user.firstShotTime){
            System.DisplayMessage("Congratulations! You just took your first shot!");
            User.user.firstShotTime = new Date().getDate() - User.user.loadDate;
            User.SaveShot();
            setTimeout(function(){ System.ClearMessage(); }, 10000);
        }

        Cue.LastShot = {speed: r.speed, t: performance.now()};
        // forward along the aim, with the measured stroke speed
        let velocity = {x:-Math.sin(Game.Camera.horizontalAngle)*r.speed, y:-Math.cos(Game.Camera.horizontalAngle)*r.speed};
        Cue.Shot(velocity);
        Cue.SendShot(velocity);
        Cue.NotifyStroke();
    },
    /** Current forward stroke speed for the power indicator (0 when idle). */
    LiveSpeed: function(t:number){
        return Cue.Enabled && Cue.StrokeActive ? Cue.Tracker.liveSpeed(t) : 0;
    },
    Shot: function(velocity:any){
        Game.Scenario.WhiteBall.PhysicalBody.SetLinearVelocity(velocity);
        Game.State.Shot();

        Cue.Distance = 1.3;
        Cue.Tracker.reset(performance.now());

        Cue.RenderedBody.position.y = 2000;
        Cue.Enabled = false;
    },
    SendShot: function(velocity:any){
        // Online: tell the opponent (via the server) that the shot started; positions follow
        // as a stream while the balls roll (Match.ts).
        Match.onShotSent(velocity);
    }
};

// stroke sensitivity setting: cue px per mouse px (1 = original)
Cue.Tracker.sensitivity = PlayerSettings.get().strokeSensitivity;
PlayerSettings.subscribe(s => { Cue.Tracker.sensitivity = s.strokeSensitivity; });

export default Cue;